import { Card, CardContent, CardHeader, CardTitle } from "@shadcn-in-nx/ui/card";
import { Shield, CheckCircle, AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import SecurityScoreGauge from "./SecurityScoreGauge";
import SecurityFindingsChart from "./SecurityFindingsChart";

const SecurityOverviewCards = ({ summary, projects }) => {
    const { t } = useTranslation();
    const { totalProjects, scannedCount, avgScore, totalFindings } = summary;
    const scannedPct = totalProjects > 0 ? Math.round((scannedCount / totalProjects) * 100) : 0;

    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="text-sm font-medium text-muted-foreground">
                        {t("security.avgScore")}
                    </CardTitle>
                </CardHeader>
                <CardContent className="flex justify-center pb-4">
                    <SecurityScoreGauge score={avgScore ?? 0} />
                </CardContent>
            </Card>

            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="text-sm font-medium text-muted-foreground">
                        {t("security.findingsBreakdown")}
                    </CardTitle>
                </CardHeader>
                <CardContent className="pb-4">
                    <SecurityFindingsChart projects={projects} />
                </CardContent>
            </Card>

            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="text-sm font-medium text-muted-foreground">
                        {t("security.overview")}
                    </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 pb-4">
                    <div className="flex items-center gap-3">
                        <Shield className="h-5 w-5 text-blue-500" />
                        <div>
                            <p className="text-2xl font-bold">{totalProjects}</p>
                            <p className="text-xs text-muted-foreground">{t("security.totalProjects")}</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-3">
                        <CheckCircle className="h-5 w-5 text-green-500" />
                        <div>
                            <p className="text-2xl font-bold">{scannedPct}%</p>
                            <p className="text-xs text-muted-foreground">{t("security.scannedProjects")}</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-3">
                        <AlertTriangle className="h-5 w-5 text-orange-500" />
                        <div>
                            <p className="text-2xl font-bold">{totalFindings}</p>
                            <p className="text-xs text-muted-foreground">{t("security.totalFindings")}</p>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default SecurityOverviewCards;
